import { copyTextToClipboard } from '../../lib/utils/copyToClipboard'

/** @deprecated Legacy query-param deep links; prefer slug paths. */
export const WEBINAR_SHARE_QUERY_PARAM = 'webinar'

export const getWebinarShareUrl = (webinar: { slug: string }) => {
  const path = `/webinars/${encodeURIComponent(webinar.slug)}`
  if (typeof window === 'undefined') return path
  return `${window.location.origin}${path}`
}

type ShareWebinarInput = {
  slug: string
}

export const shareWebinarLink = async (webinar: ShareWebinarInput) => {
  const url = getWebinarShareUrl(webinar)

  if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
    try {
      await navigator.share({ url })
      return { ok: true as const, cancelled: false as const, method: 'native' as const }
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') {
        return { ok: false as const, cancelled: true as const, method: 'native' as const }
      }
    }
  }

  const ok = await copyTextToClipboard(url)
  return { ok, cancelled: false as const, method: 'clipboard' as const }
}
